import https from "./https"
import store from "@/store"

const organization = store.state.general.organization

const organizationModuleApi = {
  list(params) {
    return https.get(`admin/organizations/${organization.id}/organization-modules`, { params })
  },
  get(id) {
    return https.get(`admin/organizations/${organization.id}/organization-modules/${id}`)
  },
  store(params) {
    return https.post(`admin/organizations/${organization.id}/organization-modules`, params)
  },
  update(params) {
    return https.put(`admin/organizations/${organization.id}/organization-modules/${params.id}`, params)
  },
  remove(id) {
    return https.delete(`admin/organizations/${organization.id}/organization-modules/${id}`)
  },
}

const organizationModuleChildrenApi = {
  list(parentId, params) {
    return https.get(
      `admin/organizations/${organization.id}/organization-module-configs/${parentId}/children`,
      { params }
    );
  },
  get(parentId, id) {
    return https.get(
      `admin/organizations/${organization.id}/organization-module-configs/${parentId}/children/${id}`
    );
  },
  store(parentId, params) {
    return https.post(
      `admin/organizations/${organization.id}/organization-module-configs/${parentId}/children`,
      params
    );
  },
  update(parentId, params) {
    return https.put(
      `admin/organizations/${organization.id}/organization-module-configs/${parentId}/children/${params.id}`,
      params
    );
  },
  remove(parentId, id) {
    return https.delete(
      `admin/organizations/${organization.id}/organization-module-configs/${parentId}/children/${id}`
    );
  },
};

export { organizationModuleApi, organizationModuleChildrenApi }
